import * as yup from 'yup';
import { ValidationMessages } from 'shared/models/Validation';
import { maxTemplateLength } from 'modules/offerLetter/components/OfferLetterForm/OfferLetterValidationsSchema';

export const TemplateValidationSchema = yup.object().shape({
    name: yup.string().trim().required(ValidationMessages.REQUIRED),
    template: yup.string().trim().required(ValidationMessages.REQUIRED)
        .max(maxTemplateLength),
});
